// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brush {
  --vis-brush-selection-fill-color: #0b1640;
  --vis-brush-selection-stroke-color: none;
  --vis-brush-selection-stroke-width: 0;
  --vis-brush-selection-opacity: 0.4;
  --vis-brush-unselected-fill-color: #fff;
  --vis-brush-unselected-stroke-color: #acb2b9;
  --vis-brush-unselected-stroke-width: 0;
  --vis-brush-unselected-opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/brush/basic-brush/style.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,qCAAqC;EACrC,kCAAkC;EAClC,uCAAuC;EACvC,4CAA4C;EAC5C,sCAAsC;EACtC,mCAAmC;AACrC","sourcesContent":[".brush {\n  --vis-brush-selection-fill-color: #0b1640;\n  --vis-brush-selection-stroke-color: none;\n  --vis-brush-selection-stroke-width: 0;\n  --vis-brush-selection-opacity: 0.4;\n  --vis-brush-unselected-fill-color: #fff;\n  --vis-brush-unselected-stroke-color: #acb2b9;\n  --vis-brush-unselected-stroke-width: 0;\n  --vis-brush-unselected-opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brush": `brush`
};
export default ___CSS_LOADER_EXPORT___;
